import { render, staticRenderFns } from "./deleteProduct.vue?vue&type=template&id=8c735c08&scoped=true"
import script from "./deleteProduct.vue?vue&type=script&lang=js"
export * from "./deleteProduct.vue?vue&type=script&lang=js"
import style0 from "./deleteProduct.vue?vue&type=style&index=0&id=8c735c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c735c08",
  null
  
)

export default component.exports